import axios from "src/lib/axios";
import { User } from "./Types";
import AlertMessage from "src/components/ui-components/AlertMessage";

const API_URLS = {
  GET_MOBILE_USERS: `/Users/GetAllUsers`,
  GET_ALL_LANGUAGES: `/Language/GetLanguages`,
  GET_ALL_CURRENCIES: `/InvestApp/GetCurrencies`,
  GET_USER_BY_USER_KEY: `/Users/GetUserByUserKey`,
  INSERT_UPDATE_USER: '/Users/InsertUpdateUsers',
  GET_USER_GROUPS: `/InvestApp/GetUserGroups`,
  ENABLE_DISABLE_MOBILE_USER: `/Users/EnableDisableMobileUser`,
  ARE_WHITELIST_USERS_PRESENT: `/Users/AreWhitelistUsersPresent`,
  GET_USER_LOGIN_LOG_SETTINGS: `/UserReporting/GetUserLoginLogSettings`,
  GENERATE_USER_LOGIN_LOG_REPORT: `/UserReporting/GenerateUserLoginLogReport`
};

export const GetAllMobileUsers = async () => {
  const mobileUserGroups = await axios.get<User[]>(API_URLS.GET_MOBILE_USERS);
  return mobileUserGroups?.data || [];
};

export const getAllLanguages = async () => {
  const response = await axios.get(API_URLS.GET_ALL_LANGUAGES);
  return response?.data || [];
};

export const getAllCurrencies = async () => {
  const response = await axios.get(API_URLS.GET_ALL_CURRENCIES);
  return response?.data || [];
};

export const getUserByUserKey = async (UserKey) => {
  const user = await axios.get<User>(API_URLS.GET_USER_BY_USER_KEY, {
    params: {
      UserKey
    }
  });
  return user.data;
};

export const InsertUpdateUser = async (user: any) => {
  try {
    const response = await axios.post(API_URLS.INSERT_UPDATE_USER, user);
    AlertMessage({ type: 'success', msg: response.data.message });
    return true;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
        AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const getAllUserGroups = async () => {
  const email = JSON.parse(localStorage.getItem('userDetails'))?.email;
  const response = await axios.get(`${API_URLS.GET_USER_GROUPS}/${email}`);
  return response?.data || [];
}

export const enableDisableMobileUser = async (isDisabled: boolean, mobileUserKey: string, ) => {
  try {
    const res = await axios.put(`${API_URLS.ENABLE_DISABLE_MOBILE_USER}?isDisabled=${isDisabled}&mobileUserKey=${mobileUserKey}`);
    AlertMessage({ type: 'success', msg: res?.data?.message });
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const AreWhitelistUsersPresent = async () => {
  const res = await axios.get<any>(API_URLS.ARE_WHITELIST_USERS_PRESENT);
  return res?.data || [];
};

export const deleteMobileUser = async (UserKey: string) => {
  try {
      const response = await axios.delete(`/Users/DeleteUser`, {
          params: { UserKey },
      });
      AlertMessage({ type: 'success', msg: response.data.message });
      return true;
  } catch (err) {
      Object.entries(err.errors || {}).forEach(([, errMsg]: any) => {
          AlertMessage({ type: 'error', msg: errMsg.errorMessage });
      });
      return false;
  }
};

export const GetUserLoginLogSettings = async () => {
  const response = await axios.get(API_URLS.GET_USER_LOGIN_LOG_SETTINGS);
  return response?.data || {};
};

export const GenerateUserLoginLogReport = async (FromDate: string, ToDate: string) => {
  try {
    const response = await axios.post(
      API_URLS.GENERATE_USER_LOGIN_LOG_REPORT, 
      { FromDate, ToDate },
      { responseType: "blob", validateStatus: (status) => status < 500 } // Accept 4xx responses for custom handling
    );

    // Check if response is not OK
    if (response.status !== 200) {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result as string);
          AlertMessage({ type: "error", msg: errorData.title || "Could not generate report" });
        } catch (parseError) {
          AlertMessage({ type: "error", msg: "Could not generate report" });
        }
      };
      reader.readAsText(response.data);
      return false;
    }

    // If response is OK, proceed with file download
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `UserLoginReport_${FromDate}_${ToDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    AlertMessage({ msg: "Report downloaded successfully", type: "success" });
    return true;
  } catch (err) {
    AlertMessage({ type: "error", msg: "Could not generate report" });
    return false;
  }
};
